import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import session from "store/session";
import providers from "store/providers";
import profile from "./profile";
import user from "./user";
import filterrole from "./filterRole";
import templates from "./templates";

export const store = configureStore({
  reducer: {
    session,
    providers,
    profile,
    user,
    filterrole,
    templates,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ["errors.error"],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
